import { areaState } from '@/app/model/store/domain/types.ts'

export default {
  setAreaList (state: areaState, payload: any) {
    state.areaData = payload
  },
  setSearchText (state: areaState, payload: string) {
    state.searchText = payload
  },
  setSortName (state: areaState, sortName: string) {
    state.sortName = sortName
  },
  setSortAsc (state: areaState, sort: boolean) {
    state.sortAsc = sort
  }
}
